import React from "react";
import styled from "styled-components";
import Loader from "react-loader-spinner";
// Constants
import { primaryColor } from "../config/constants";

export const LoaderDiv = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 100px;
`;

const LoaderComponent = () => (
  <LoaderDiv>
    <Loader type="Oval" color={primaryColor} height={100} width={100} />
  </LoaderDiv>
);

export default LoaderComponent;
